import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import FAQ from 'features/components/base/faq/FAQ';
import FAQArticleDetail from 'features/components/base/faq/FAQArticleDetail';

export class HelpRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path="/help-center" component={FAQ} />
                <Route exact path="/help-center/folder/:folderid" component={FAQ} />
                <Route exact path="/help-center/article/:pageid" component={FAQArticleDetail} />
                <Route exact path="/help-center/:section" component={FAQ} />
                <Redirect to="/help-center" />
            </Switch>
        );
    }
}
